import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { StrictMode } from "react";
import * as Sentry from "@sentry/react";
import { isDev } from "config";

//업데이트 사항 있으면 강제 새로고침
// Service Worker 등록
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("/service-worker.js")
//     .then((registration) => {
//       // 메시지 리스너 등록
//       navigator.serviceWorker.addEventListener("message", (event) => {
//         if (event.data.type === "CACHE_UPDATED") {
//           // 업데이트된 캐시에 대한 처리
//           console.log("New cache available: ", event.data.newCache);
//           // 사용자에게 페이지 새로고침을 권장하거나 자동 새로고침을 수행
//           window.location.reload();
//         }
//       });
//     })
//     .catch((err) => {
//       console.log("ServiceWorker registration failed: ", err);
//     });
// }
Sentry.init({
  dsn: "https://47ff8d768160cd581fa4fafb69a77d57@o4504052882407424.ingest.sentry.io/4506102643949568",
  environment: isDev ? "dev" : "main",
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 1.0,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
